<template>
  <div class="layout-container">
    <!-- 侧边栏菜单 -->
    <div class="sidebar-menu" :class="{ collapsed: isCollapsed }">
      <!-- 菜单头部 -->
      <div class="menu-header">
        <div class="logo-area" v-show="!isCollapsed">
          <i class="el-icon-s-platform logo-icon"></i>
          <span class="logo-text">系统中心</span>
        </div>
        <div class="collapse-btn" @click="toggleCollapse">
          <i :class="isCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
        </div>
      </div>

      <!-- 菜单内容 -->
      <div class="menu-content">
        <el-menu
          :default-active="activeIndex"
          :default-openeds="defaultOpeneds"
          class="custom-menu"
          :collapse="isCollapsed"
          background-color="#ffffff"
          text-color="#606266"
          :active-text-color="primaryColor"
          router
          @select="handleMenuSelect"
        >
          <template v-for="item in showMenuList">
            <template v-if="!item.isHide">
              <!-- 有子菜单的情况 -->
              <el-submenu v-if="item.children && item.children.length > 0" :index="item.index" :key="item.index">
                <template slot="title">
                  <i :class="item.icon"></i>
                  <span>{{ item.name }}</span>
                </template>
                <template v-for="child in item.children">
                  <el-menu-item :index="child.path" v-if="!child.isHide" :key="child.index">
                    <UseSvg :svg-name="child.svgName" default-fill="#606266"></UseSvg>
                    <span>{{ child.name }}</span>
                  </el-menu-item>
                </template>
              </el-submenu>

              <!-- 没有子菜单的情况 -->
              <el-menu-item v-else :index="item.path" :key="item.index">
                <i :class="item.icon"></i>
                <span slot="title">{{ item.name }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content" :class="{ expanded: isCollapsed }">
      <!-- 顶部导航栏 -->
      <div class="top-navbar">
        <div class="nav-left">
          <div class="breadcrumb">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/new-products' }">首页</el-breadcrumb-item>
              <template v-for="(item, index) in breadcrumbList">
                <el-breadcrumb-item
                  v-if="item.path && index !== breadcrumbList.length - 1"
                  :key="index"
                  :to="{ path: item.path }"
                >
                  {{ item.name }}
                </el-breadcrumb-item>
                <el-breadcrumb-item v-else :key="index">
                  {{ item.name }}
                </el-breadcrumb-item>
              </template>
            </el-breadcrumb>
          </div>
        </div>
      </div>

      <!-- 页面内容 -->
      <div class="page-content">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import UseSvg from "../../components/common/UseSvg.vue";

export default {
  name: "LayoutContainer",
  components: {
    UseSvg
  },
  data() {
    return {
      showMenuList: [],
      menuList: [
        {
          name: "首页",
          path: "/new-products",
          index: "1",
          icon: "el-icon-house"
        },
        {
          name: "我的订单",
          index: "2",
          icon: "el-icon-s-order",
          children: [
            {
              name: "订单列表",
              index: "2-1",
              svgName: "orderList",
              path: "/new-products/system-center/order-list"
            }
          ]
        },
        {
          name: "对账中心",
          index: "4",
          icon: "el-icon-s-order",
          children: [
            {
              name: "往来对账",
              index: "4-1",
              svgName: "orderList",
              path: "/new-products/system-center/wl-reconciliation"
            }
          ]
        },
        {
          name: "管理中心",
          index: "3",
          icon: "el-icon-s-tools",
          children: [
            {
              name: "个人资料",
              index: "3-1",
              svgName: "userInfo",
              path: "/new-products/system-center/personal-data"
            },
            {
              name: "企业资料",
              index: "3-2",
              svgName: "companyInfo",
              path: "/new-products/system-center/company-data"
            },
            {
              name: "我的钱包",
              index: "3-3",
              svgName: "myWallet",
              path: "/new-products/system-center/my-wallet"
            },
            {
              name: "员工管理",
              index: "3-4",
              svgName: "staff",
              path: "/new-products/system-center/staff"
            },
            {
              name: "地址管理",
              index: "3-5",
              svgName: "address",
              path: "/new-products/system-center/address"
            },
            {
              name: "关联思锐ERP",
              index: "3-6",
              svgName: "associated",
              path: "/new-products/system-center/associated"
            }
          ]
        }
      ],
      isCollapsed: false,
      activeIndex: "",
      breadcrumbList: [],
      defaultOpeneds: ["2", "3", "4"] // 默认展开的菜单
    };
  },
  computed: {
    ...mapState("theme", ["primaryColor"]),
    ...mapGetters("user", ["permissions", "userInfo"]),
    ...mapState("companyInfo", {
      company: state => state.company
    }),
    // 商城是否启用客户往来账展示
    enableCustomerStatement() {
      return !!(this.company.setting || {}).enableCustomerStatement;
    }
  },
  watch: {
    $route: {
      handler(newRoute) {
        this.activeIndex = newRoute.path;
        this.updateBreadcrumb();
        // this.$bus.$emit("scrollTop");
        // this.updateDefaultOpeneds();
      },
      immediate: true
    },
    // 商城配置变更（如启用/关闭往来账）后，重新计算菜单显示
    enableCustomerStatement() {
      this.showMenuList = this.setPermissions(this.menuList);
    },
    permissions() {
      this.showMenuList = this.setPermissions(this.menuList);
    },
    userInfo: {
      deep: true,
      immediate: true,
      handler: function(val) {
        if (val) {
          this.showMenuList = this.setPermissions(this.menuList);
        }
      }
    }
  },
  methods: {
    setPermissions(list) {
      for (const item of list) {
        // 控制显示 对账单|企业资料|员工管理
        if (item.name === "对账中心") {
          item.isHide = !(this.permissions.others.statement && this.enableCustomerStatement);
        }
        if (item.name === "员工管理") {
          item.isHide = !(this.permissions.others.staffs && this.userInfo.isCompany);
        }
        if (item.children && item.children.length) {
          item.children = this.setPermissions(item.children);
        }
      }
      return list;
    },
    updateBreadcrumb() {
      const path = this.$route.path;
      const breadcrumbs = [];
      if (path === "/new-products/system-center/order-list") {
        breadcrumbs.push({ name: "我的订单", path: null }, { name: "订单列表", path: null });
        this.breadcrumbList = breadcrumbs;
        return;
      }
      if (path === "/new-products/system-center/wl-reconciliation") {
        breadcrumbs.push({ name: "对账中心", path: null }, { name: "往来对账", path: null });
        this.breadcrumbList = breadcrumbs;
        return;
      }
      // if (path.includes("wl-reconciliation")) {
      //   breadcrumbs.push({ name: "往来对账", path: "/new-products/system-center/wl-reconciliation" });
      //   this.breadcrumbList = breadcrumbs;
      //   return;
      // }
      if (path.includes("order-list")) {
        breadcrumbs.push({ name: "订单列表", path: "/new-products/system-center/order-list" });
      } else if (path.includes("wl-reconciliation")) {
        breadcrumbs.push({ name: "往来对账", path: "/new-products/system-center/wl-reconciliation" });
      } else {
        breadcrumbs.push({ name: "管理中心", path: null });
      }
      breadcrumbs.push({ name: this.$route.name, path: null });
      // 根据当前路径生成面包屑
      // if (path.includes("order-list")) {
      //   breadcrumbs.push({ name: "我的订单", path: null }, { name: "订单列表", path: null });
      // } else if (path.includes("personal-data")) {
      //   breadcrumbs.push({ name: "管理中心", path: null }, { name: "个人资料", path: null });
      // } else if (path.includes("company-data")) {
      //   breadcrumbs.push({ name: "管理中心", path: null }, { name: "企业资料", path: null });
      // } else if (path.includes("my-wallet")) {
      //   breadcrumbs.push({ name: "管理中心", path: null }, { name: "我的钱包", path: null });
      // } else if (path.includes("staff")) {
      //   breadcrumbs.push({ name: "管理中心", path: null }, { name: "员工管理", path: null });
      // } else if (path.includes("address")) {
      //   breadcrumbs.push({ name: "管理中心", path: null }, { name: "地址管理", path: null });
      // } else if (path.includes("associated")) {
      //   breadcrumbs.push({ name: "管理中心", path: null }, { name: "关联思锐ERP", path: null });
      // } else if (path === "/new-products") {
      //   breadcrumbs.push({ name: "首页", path: null });
      // } else {
      //   // 默认面包屑
      //   breadcrumbs.push({ name: "页面", path: null });
      // }

      this.breadcrumbList = breadcrumbs;
    },

    updateDefaultOpeneds() {
      // 根据当前路由设置默认展开的菜单
      const path = this.$route.path;
      const defaultOpeneds = [];
      const list = ["personal-data", "company-data", "my-wallet", "staff", "address", "associated"];
      if (path.includes("order-list")) {
        defaultOpeneds.push("2");
      } else if (path.includes("wl-reconciliation")) {
        defaultOpeneds.push("4");
      } else if (list.some(e => path.includes(e))) {
        defaultOpeneds.push("3");
      }

      this.defaultOpeneds = defaultOpeneds;
    },

    handleMenuSelect(index) {
      this.activeIndex = index;
    },

    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    }
  },
  created() {
    // this.showMenuList = this.setPermissions(this.menuList);
  },
  mounted() {
    this.activeIndex = this.$route.path;
    this.updateBreadcrumb();
    // this.updateDefaultOpeneds();
  }
};
</script>
<style lang="scss">
.text-primary {
  color: var(--color-primary);
}
// .menu-content li.is-active svg {
//   path {
//     fill: var(--color-primary) !important;
//   }
// }
.menu-content .el-menu-item.is-active {
  svg {
    path {
      fill: var(--color-primary) !important;
    }
  }
}
.menu-content .is-active > .el-submenu__title {
  color: var(--color-primary) !important;
}
.menu-content .el-menu-item:hover {
  svg {
    path {
      fill: var(--color-primary) !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.layout-container {
  display: flex;
  min-height: 100vh;
  // overflow: hidden;

  // 侧边栏样式 - 浅色主题
  .sidebar-menu {
    width: 160px;
    // height: 100%;
    background-color: #ffffff;
    transition: width 0.3s;
    display: flex;
    flex-direction: column;
    box-shadow: 2px 0 6px rgba(0, 0, 0, 0.05);
    border-right: 1px solid #e6e8eb;

    &.collapsed {
      width: 64px;
    }

    // 菜单头部
    .menu-header {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 8px;
      padding: 0 20px;
      border-bottom: 1px solid #e6e8eb;

      .logo-area {
        display: flex;
        align-items: center;

        .logo-icon {
          font-size: 24px;
          color: var(--color-primary);
          margin-right: 8px;
        }

        .logo-text {
          color: #303133;
          font-size: 18px;
          font-weight: 600;
          white-space: nowrap;
          transition: opacity 0.3s;
        }
      }

      .collapse-btn {
        color: #606266;
        font-size: 18px;
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: var(--color-primary);
        }
      }
    }

    // 菜单内容
    .menu-content {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;

      .custom-menu {
        border: none;

        // 解决折叠时菜单项文字显示问题
        &:not(.el-menu--collapse) {
          width: 100%;
        }

        // 完全禁用所有过渡效果
        // ::v-deep {
        //   .el-submenu .el-menu {
        //     transition: none !important;
        //   }

        //   .el-menu--inline {
        //     transition: none !important;
        //   }

        //   .el-submenu__title {
        //     transition: none !important;
        //   }

        //   .el-menu-item {
        //     transition: none !important;
        //   }
        // }
        .el-menu-item {
          padding-left: 20px !important;
        }
        .el-menu-item,
        .el-submenu__title {
          height: 50px;
          line-height: 50px;

          i {
            margin-right: 8px;
            font-size: 16px;
            color: #606266;
          }

          &:hover {
            background-color: #f5f7fa !important;
            color: var(--color-primary) !important;
            i {
              color: var(--color-primary);
            }
          }
        }

        .el-menu-item.is-active {
          background-color: color-mix(in srgb, var(--color-light80) 30%, transparent) !important;
          position: relative;
          color: var(--color-primary);

          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 4px;
            background-color: var(--color-primary);
          }

          i {
            color: var(--color-primary);
          }
        }

        // 子菜单标题样式调整
        .el-submenu__title {
          &:hover {
            background-color: #f5f7fa !important;
            color: var(--color-primary);

            i {
              color: var(--color-primary);
            }
          }
        }

        // 激活的子菜单样式
        .el-submenu.is-active .el-submenu__title {
          color: var(--color-primary);

          i {
            color: var(--color-primary);
          }
        }
      }
    }
  }

  // 主内容区域
  .main-content {
    width: calc(100% - 160px);
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    background-color: #f0f2f5;
    transition: width 0.3s;

    &.expanded {
      width: calc(100% - 64px);
    }

    // 顶部导航栏
    .top-navbar {
      height: 60px;
      background-color: #fff;
      box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      z-index: 10;

      .nav-left {
        .breadcrumb {
          ::v-deep .el-breadcrumb {
            font-size: 14px;

            .el-breadcrumb__inner {
              color: #606266;

              &.is-link {
                color: var(--color-primary);
                font-weight: normal;

                &:hover {
                  color: var(--color-light60);
                }
              }
            }

            .el-breadcrumb__item:last-child .el-breadcrumb__inner {
              color: #303133;
              font-weight: 600;
            }
          }
        }
      }
    }

    // 页面内容区域
    .page-content {
      flex: 1;
      padding: 12px;
      overflow-y: auto;
    }
  }
}

// 滚动条样式优化 - 浅色主题适配
.sidebar-menu ::-webkit-scrollbar {
  width: 4px;
}

.sidebar-menu ::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
}

.sidebar-menu ::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}

.sidebar-menu ::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

// 响应式设计
@media (max-width: 768px) {
  .layout-container {
    .sidebar-menu {
      position: fixed;
      left: 0;
      top: 0;
      z-index: 1000;
      transform: translateX(-100%);
      transition: transform 0.3s;

      &.mobile-open {
        transform: translateX(0);
      }
    }

    .main-content {
      width: 100%;

      .top-navbar {
        padding: 0 12px;
      }

      .page-content {
        padding: 12px;
      }
    }
  }

  // 移动端遮罩层
  .mobile-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
}
</style>
